module.exports = __webpack_public_path__ + "img/arw-right.4f30e153.svg";